import { useEffect } from "react";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";

import ArticleSubshareModal from "./ArticleSubshareModal";
import ArticleSubsharePromptContent from "./ArticleSubsharePromptContent";

type ArticleSubsharePromptProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ArticleSubsharePrompt({
  isModalOpen,
  setIsModalOpen,
}: ArticleSubsharePromptProps): React.ReactElement {
  const sendDataToGTM = useSendDataToGTM();

  useEffect(() => {
    if (!isModalOpen) return;

    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "visible",
      eventLabel: "get unlimited access to premium bt stories",
    });
  }, [isModalOpen, sendDataToGTM]);

  return (
    <ArticleSubshareModal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    >
      <ArticleSubsharePromptContent setIsModalOpen={setIsModalOpen} />
    </ArticleSubshareModal>
  );
}
